<template>
    <vue-good-table
        @on-page-change="onPageChange"
        :columns="columns"
        :rows="logs"
        :totalRows="totalRows"
        mode="remote"
        :pagination-options="vgtPaginationOptions">
        <template slot="table-row" slot-scope="props">
            <small v-if="props.column.field === 'event'">
                {{ getEventName(props.row.event) || "-" }}
            </small>
            <small v-else-if="props.column.field === 'level'" class="font-weight-bold"
                   :style="{ color: getAlarmLevelColor(props.row.context.level) }">
                {{ getAlarmLevelName(props.row.context.level) || "-" }}
            </small>
            <small v-else-if="props.column.field === 'context'" class="font-weight-bold">
                <AccidentLogContext :context="props.row.context"
                                    :deviceObject="currentDeviceObject"/>
            </small>
            <small v-else-if="props.column.field === 'created_at'">
                {{ dateFormat(props.row.created_at) }}
            </small>
            <div v-else>
                {{ props.formattedRow[props.column.field] }}
            </div>
        </template>
    </vue-good-table>
</template>

<script>

import config from "../config";
import moment from "moment-mini";
import DeviceObject from "../objects/DeviceObject";
import {mapState} from "vuex";
import types from "../store/types";
import AccidentLogContext from "./AccidentLogContext";
import AccidentService from "../services/AccidentService";

const Accident = new AccidentService();

export default {
    name: "AccidentLogTable",
    components: {
        AccidentLogContext
    },
    props: {
        currentAccident: {
            required: true
        }
    },
    data() {
        return {
            columns: [
                {
                    label: this.$t('Событие'),
                    field: 'event',
                    sortable: false,
                },
                {
                    label: this.$t('Уровень'),
                    field: 'level',
                },
                {
                    label: this.$t('Контекст'),
                    field: 'context',
                    sortable: false,
                    width: "300px"
                },
                {
                    label: this.$t('Дата'),
                    field: 'created_at',
                    sortable: false,
                }
            ],
            logs: [],
            totalRows: 0,
            currentPage: 1,
            perPage: 20
        }
    },
    methods: {
        async onPageChange({currentPage}) {
            this.currentPage = currentPage;
            await this.loadLogs()
        },
        dateFormat(date) {
            return date ? moment(date).format("YYYY-MM-DD HH:mm:ss") : "-"
        },
        getAlarmLevelColor(level) {
            return config.alarmLevelColors[level];
        },
        getAlarmLevelName(level) {
            return config.alarmLevels[level];
        },
        getEventName(event) {
            const names = {
                created: this.$t('Создано'),
                updated: this.$t('Обновлено'),
                deleted: this.$t('Завершено'),
            };

            return names[event];
        },
        async loadLogs() {
            this.$store.commit(types.SIMPLE_PRELOADER, true);
            const body = await Accident.fetchLog(this.currentAccidentId, this.currentPage);
            this.logs = body["hydra:member"];
            this.totalRows = body["hydra:totalItems"];
            this.$store.commit(types.SIMPLE_PRELOADER, false);
        },
    },
    watch: {
        async currentAccident() {
            this.currentPage = 1;

            await this.$nextTick();
            await this.loadLogs();
        }
    },
    computed: {
        ...mapState({
            devices: state => state.devices
        }),
        vgtPaginationOptions() {
            return config.vgtPaginationOptions({
                perPage: this.perPage,
                perPageDropdown: [this.perPage],
                setCurrentPage: this.currentPage
            })
        },
        currentAccidentDeviceId() {
            return this.currentAccident.device.split("/").reverse()[0];
        },
        currentAccidentId() {
            return this.currentAccident['@id'].split("/").reverse()[0];
        },
        currentAccidentAlarmId() {
            return this.currentAccident.alarm['@id'].split("/").reverse()[0];
        },
        currentDevice() {
            return this.devices.find(item => item.id === this.currentAccidentDeviceId);
        },
        currentDeviceObject() {
            return new DeviceObject(this.currentDevice)
        }
    },
}
</script>

<style scoped>

</style>
